<template>
  <div class="test-container">
    <h1 class="page-title">比赛管理系统</h1>

    <!-- 按钮区域 -->
    <div class="button-group">
      <el-button
        type="primary"
        class="call-btn"
        @click="showCallModal"
        icon="el-icon-phone"
        size="large"
      >
        📢 查看呼叫记录
      </el-button>
    </div>

    <!-- 呼叫记录弹窗 -->
    <transition name="modal-fade">
      <div v-if="modalVisible" class="modal-overlay" @click="closeModal">
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <div class="header-icon">📢</div>
            <h3>呼叫记录明细</h3>
            <button class="close-btn" @click="closeModal">×</button>
          </div>
          <div class="modal-body">
            <div class="call-list">
              <div
                v-for="(item, index) in callRecords"
                :key="index"
                class="call-item"
                :class="item.type"
              >
                <div class="call-item-icon">{{ item.icon }}</div>
                <div class="call-item-content">
                  <div class="call-item-title">
                    {{ item.venue }}呼叫{{ item.target }}
                  </div>
                  <div class="call-item-time">{{ item.time }}</div>
                </div>
                <div class="call-item-status" :class="item.status">
                  {{ item.statusText }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <el-button type="primary" @click="closeModal" class="confirm-btn">
                确定
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Test",
  data() {
    return {
      modalVisible: false,
      callRecords: [
        {
          venue: "1号场地",
          target: "裁判长",
          icon: "📢",
          time: "2024-01-15 14:30:25",
          type: "referee",
          status: "processing",
          statusText: "处理中"
        },
        {
          venue: "1号场地",
          target: "队医",
          icon: "🏥",
          time: "2024-01-15 14:28:10",
          type: "doctor",
          status: "completed",
          statusText: "已完成"
        },
        {
          venue: "2号场地",
          target: "裁判长",
          icon: "📢",
          time: "2024-01-15 14:25:45",
          type: "referee",
          status: "processing",
          statusText: "处理中"
        },
        {
          venue: "3号场地",
          target: "裁判长",
          icon: "📢",
          time: "2024-01-15 14:20:30",
          type: "referee",
          status: "completed",
          statusText: "已完成"
        }
      ]
    };
  },
  created() {},
  methods: {
    // 显示呼叫记录弹窗
    showCallModal() {
      this.modalVisible = true;
    },

    // 关闭呼叫记录弹窗
    closeModal() {
      this.modalVisible = false;
    }
  }
};
</script>

<style scoped>
.test-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.page-title {
  color: white;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 60px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  animation: fadeInDown 0.8s ease-out;
}

.button-group {
  display: flex;
  gap: 40px;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.call-btn {
  padding: 20px 40px;
  font-size: 20px;
  font-weight: 600;
  border-radius: 12px;
  border: none;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.call-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.4);
}

/* 模态框遮罩层 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(8px);
}

/* 模态框容器 */
.modal-container {
  background: white;
  border-radius: 24px;
  width: 90%;
  max-width: 700px;
  max-height: 80vh;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: modalSlideIn 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  display: flex;
  flex-direction: column;
}

/* 模态框头部 */
.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex-shrink: 0;
}

.header-icon {
  font-size: 40px;
  animation: bounce 1s infinite;
}

.modal-header h3 {
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 32px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* 模态框主体 */
.modal-body {
  padding: 30px;
  overflow-y: auto;
  flex: 1;
}

/* 呼叫列表 */
.call-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.call-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border-left: 4px solid #667eea;
  transition: all 0.3s ease;
  animation: slideInRight 0.4s ease-out;
}

.call-item:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.call-item.doctor {
  border-left-color: #11998e;
}

.call-item-icon {
  font-size: 32px;
  margin-right: 15px;
  flex-shrink: 0;
}

.call-item-content {
  flex: 1;
}

.call-item-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.call-item-time {
  font-size: 14px;
  color: #999;
}

.call-item-status {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
}

.call-item-status.processing {
  background: #fff3e0;
  color: #f57c00;
}

.call-item-status.completed {
  background: #e8f5e9;
  color: #2e7d32;
}

.modal-footer {
  display: flex;
  gap: 15px;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.confirm-btn {
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

/* 动画效果 */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.7) translateY(-50px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* 模态框淡入淡出动画 */
.modal-fade-enter-active {
  animation: modalFadeIn 0.3s ease-out;
}

.modal-fade-leave-active {
  animation: modalFadeOut 0.3s ease-in;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalFadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-title {
    font-size: 32px;
    margin-bottom: 40px;
  }

  .button-group {
    flex-direction: column;
    gap: 20px;
  }

  .call-btn {
    width: 100%;
    max-width: 300px;
  }

  .modal-container {
    width: 95%;
    max-height: 90vh;
  }

  .call-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .call-item-icon {
    margin-right: 0;
  }

  .call-item-status {
    align-self: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newsGlIndex/Test.vue